import { Box } from "@bpba/ui-components";
import styled from "styled-components";
import { BackgroundColorProps } from "styled-system";
import { ReactComponent as ArrowTopComponent } from "../../assets/icons/arrowTopComponent.svg";
import { ErrorBoundary } from "../ErrorBoundary";
import { BP_CONTAINER_PAD_Y } from "../../constants/data";

const SIZE_MOBILE = "50px";
const SIZE_TABLET_DESKTOP = "50px";

type Props = {
  orden: number;
} & BackgroundColorProps;

export const TopComponent = (props: Props) => {
  const { orden, ...otherProps } = props;
  const backToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ErrorBoundary>
      <Box
        paddingY={BP_CONTAINER_PAD_Y}
        justifyContent={"center"}
        title="volver al inicio"
        {...otherProps}
        backgroundColor={props.backgroundColor || "secondary.2"}
      >
        <StyledArrowContainer
          onClick={backToTop}
          width={[SIZE_MOBILE, SIZE_TABLET_DESKTOP]}
          height={[SIZE_MOBILE, SIZE_TABLET_DESKTOP]}
        >
          <ArrowTopComponent />
        </StyledArrowContainer>
      </Box>
    </ErrorBoundary>
  );
};

const StyledArrowContainer = styled(Box)(
  {
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    border: "1px solid",
    cursor: "pointer",
    stroke: "2px",
  },
  (props) => ({
    ":hover": {
      backgroundColor: props.theme.colors.secondary[1],
      color: "white",
      fill: "white",
    },
  })
);
